import axios from 'axios'

export default {
    getItems: function(area, cb) {
        axios.get('/api/side/area/' + area)
            .then(cb)
            .catch(error => {
                console.log(error)
            })
    }
}

